import { configureStore } from '@reduxjs/toolkit';
import { authReducer, userReducer, NftReducer } from './slice';

// ***************************************************

const reducer = {
  auth: authReducer,
  user: userReducer,
  nft: NftReducer,
};

// ***************************************************

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
